import { RouteIdEnum } from 'config/enums'
import DashboardLayout from 'layouts/layouts/DashboardLayout/DashboardLayout'
import ClientPROTable from './ClientPROTable'

const Index = () => {
    return (
        <DashboardLayout
            title={"Gestion des Client PRO"}
            selectedPath={RouteIdEnum.ClientsPRO}
        >
          <ClientPROTable/>
        </DashboardLayout>
    )
}

export default Index